import debug from "debug";
const log = debug("slideshow:SlideScaler");

/**
 * Scales the samples down so they fit the viewport, with "responsive padding".
 * Scoped to one slideshow so that several on a page don't measure each other.
 */
export class SlideScaler {
  static PADDINGS = {
    // keyed by the smallest window.innerWidth they apply to
    0: { x: 25, y: 15 },
    320: { x: 50, y: 30 },
    425: { x: 100, y: 60 },
    768: { x: 200, y: 120 },
  };

  /**
   * @param {HTMLElement} slideshowElement
   */
  constructor(slideshowElement) {
    if (!slideshowElement) {
      throw new Error("slideshowElement is required");
    }
    this.slideshowElement = slideshowElement;
  }

  start() {
    this._onResize = () => this.apply();
    this.apply();
    window.addEventListener("resize", this._onResize);
  }

  stop() {
    if (this._onResize) {
      window.removeEventListener("resize", this._onResize);
      this._onResize = null;
    }
  }

  apply() {
    const padding = this.paddingForWindowWidth();
    const headerElement =
      this.slideshowElement.querySelector(".slide-font-style");
    if (!headerElement) {
      return;
    }

    const headerTop = headerElement.getBoundingClientRect().top;
    const slideshowTop = this.slideshowElement.getBoundingClientRect().top;
    const headerTopRelativeToSlideshow = headerTop - slideshowTop;
    const headerHeight = headerTopRelativeToSlideshow + padding.y;
    log(`headerHeight: ${headerHeight}`);

    const slideshowElement = this.slideshowElement;

    this.slideshowElement
      .querySelectorAll(".rendered_text")
      .forEach((element) => {
        // width
        const containerWidth = slideshowElement.clientWidth;
        const availableWidth = containerWidth - padding.x;
        const elementWidth = element.clientWidth;
        const scalingFactorX =
          elementWidth > availableWidth ? availableWidth / elementWidth : 1;
        log(
          `scalingFactorX: ${scalingFactorX} (elementWidth: ${elementWidth}, availableWidth: ${availableWidth}, containerWidth: ${containerWidth}, padding.x: ${padding.x})`,
        );

        // height
        const containerHeight = slideshowElement.clientHeight;
        const availableHeight = containerHeight - headerHeight;
        const elementHeight = element.clientHeight;
        const scalingFactorY =
          elementHeight > availableHeight ? availableHeight / elementHeight : 1;
        log(
          `scalingFactorY: ${scalingFactorY} (elementHeight: ${elementHeight}, availableHeight: ${availableHeight}, containerHeight: ${containerHeight}, headerHeight: ${headerHeight})`,
        );

        element.style.transform = `scale(${Math.min(scalingFactorX, scalingFactorY)})`;
      });
  }

  paddingForWindowWidth() {
    const key = Object.keys(SlideScaler.PADDINGS)
      .map((width) => parseInt(width))
      .reduce((acc, width) =>
        width > this.slideshowElement.clientWidth ? acc : width,
      );

    return SlideScaler.PADDINGS[key];
  }
}
